import { PATHS } from "@/lib/router";
import { OnboardingPage } from "./pages";

export const onboardingRoutes = [
  {
    path: `${PATHS.ONBOARD}/:project?`,
    element: <OnboardingPage />,
  },
];
